import styled from '@emotion/styled';
import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { CloseIcon, Css, ITheme, SearchIcon } from '../../../ui';
import { Input } from '../input/Input';

const ClearWrapper = styled.div`
	position: absolute;
	right: 0;
	top: 0;
	bottom: 0;
	padding: ${Css.pxToRem(16)};
	pointer-events: none;
	align-items: center;
	display: none;

	input:not(:placeholder-shown) ~ & {
		display: flex;
	}
`;

const ClearButton = styled.button<{}, ITheme>`
	pointer-events: all;
	border: none;
	margin: 0;
	cursor: pointer;
	border-radius: 50%;
	padding: ${Css.pxToRem(4)};
	transition: background 0.15s ease-in-out;
	background: transparent;
`;

interface IProps
	extends Omit<ComponentPropsWithoutRef<'input'>, 'placeholder'> {
	label: string;
	labelId?: string;
	onClear: () => void;
	isInvalid?: boolean;
	value?: string;
}

export const SearchInput = forwardRef<HTMLInputElement, IProps>(
	({ label, labelId, onClear, isInvalid, ...rest }, ref) => (
			<Input
				label={label}
				labelId={labelId}
				isInvalid={isInvalid}
				icon={<SearchIcon aria-hidden />}
				ref={ref}
				{...rest}
			>
				<ClearWrapper>
					<ClearButton
						type="button"
						aria-label="Clear search"
						onClick={onClear}
					>
						<CloseIcon aria-label="Cancel" />
					</ClearButton>
				</ClearWrapper>
			</Input>
		),
);

SearchInput.displayName = 'SearchInput';
